import type {
  ArchivedConversation,
  ArchivedConversationsResponse,
  ConversationChangeRequest,
  ConversationChangeResponse,
  ConversationSearchHit,
  ConversationSearchResponse,
  SaveDraftConversationRequest,
  SaveDraftConversationResponse,
} from '@crowdex/agent-contracts/api';
import { apiFetch } from '@crowdex/host-kit/renderer/http';

/** The sidebar's changes to a conversation (`/api/conversations/:id`, D22). */
const path = (conversationId: string) => `/api/conversations/${encodeURIComponent(conversationId)}`;

export function changeConversation(
  conversationId: string,
  change: ConversationChangeRequest,
): Promise<ConversationChangeResponse> {
  return apiFetch<ConversationChangeResponse>(path(conversationId), {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(change),
  });
}

/** Saves a conversation nothing was sent in yet, where it will run (an app opened in it). */
export function saveDraftConversation(
  conversationId: string,
  input: SaveDraftConversationRequest,
): Promise<SaveDraftConversationResponse> {
  return apiFetch<SaveDraftConversationResponse>(path(conversationId), {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export async function deleteConversationForGood(conversationId: string): Promise<void> {
  await apiFetch(path(conversationId), { method: 'DELETE' });
}

/** The user's archived conversations, the latest first (the cloud's too, on a machine). */
export async function listArchivedConversations(): Promise<ArchivedConversation[]> {
  return (await apiFetch<ArchivedConversationsResponse>('/api/conversations/archived'))
    .conversations;
}

/** The conversations whose messages say `query` (two letters at least). */
export async function searchConversationMessages(
  query: string,
  signal?: AbortSignal,
): Promise<ConversationSearchHit[]> {
  return (
    await apiFetch<ConversationSearchResponse>(
      `/api/conversations/search?q=${encodeURIComponent(query)}`,
      signal === undefined ? {} : { signal },
    )
  ).conversations;
}
